module.exports = __webpack_public_path__ + "media/Puzzle_Game_PowerUp_Light_03.29942dd6.wav";